import React, { Component } from 'react'

export default class Feeds extends Component {
    render() {
        return (
            <div>
                Feeds TODO
            </div>
        )
    }
}
